export default class MessageHandler {
    
    static showFailMessage(formId, id, showModal = true){
        let errorMessage = $("#" + id);
        if (errorMessage.length == 0) {
            errorMessage = $("#" + formId).find('[name=' + id + ']');
        }

        // Remove previous error classes
        $('.show--error').removeClass('show--error');
        // $('.d-flex').removeClass('d-flex'); // Remove d-flex from any previously displayed error message

        // Add the show--error class to the parent
        $(errorMessage).parent().addClass("show--error");

        // // Show the error message by adding d-flex class to the span
        // let errorSpan = $("#" + formId).find('.error-message');
        // if (errorSpan.length) {
        //     errorSpan.addClass('d-flex');
        // }

        try {
            if(showModal) this.showErrorModal(id);
        } catch (error) {
            // Handle errors silently
        }
    }

    static showErrorModal(id){
        const message =  document.getElementById(id).innerHTML
        const modal = document.getElementById('error-message-forms')
        const modalDescription = document.querySelector('#error-message-forms .description')

        modalDescription.innerHTML = message
        modal.classList.add("open-modal")
    }

    static removeAllFormFailMessages(selector = ".message-error-removed", elementClass = 'activate'){
        const inputGroup = document.querySelectorAll(selector);
        inputGroup.forEach(group => {
            group.classList.remove(elementClass);
        })
        $(".show--error").removeClass('show--error')
    }
}
